<div class="card-content-head">
  <!-- mat-icon はこの位置 -->
  <ng-content select=".card-content-head-icon"></ng-content>
  <!-- タイトル部分 -->
  <div class="card-content-head-label" role="heading"><ng-content></ng-content></div>
  <!-- 右肩領域 -->
  <ng-content select=".card-content-head-util"></ng-content>
</div>
